var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNiChevronTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 5.5,
    height: 10,
    viewBox: "0 0 5.5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0.239665 0.200408C-0.0638681 0.48226 -0.081444 0.956809 0.200408 1.26034L3.72652 5L0.200408 8.73967C-0.0814437 9.0432 -0.0638678 9.51775 0.239665 9.7996C0.543198 10.0815 1.01775 10.0639 1.2996 9.76034L5.2996 5.51034C5.5668 5.22258 5.5668 4.77743 5.2996 4.48966L1.2996 0.239665C1.01775 -0.0638681 0.543198 -0.081444 0.239665 0.200408Z",
    fill: "#0A829D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiChevronTeal);
export default __webpack_public_path__ + "static/media/ni-chevron-teal.e73f1897d629793f4f4e441649b1c430.svg";
export { ForwardRef as ReactComponent };